import Main from './main.vue';
import elementMethods from './elementMethods';

Main.install = function (Vue) {
    Vue.component(Main.name, Main);
};
Main._mixinsMethods = elementMethods;
export default Main;



// WEBPACK FOOTER //
// ./src/index.js